import { render } from "./TabBodyRecent.vue?vue&type=template&id=52715eea&scoped=true"
import script from "./TabBodyRecent.vue?vue&type=script&lang=js"
export * from "./TabBodyRecent.vue?vue&type=script&lang=js"

import "./TabBodyRecent.vue?vue&type=style&index=0&id=52715eea&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52715eea"]])

export default __exports__